export enum TabsEnum {
	AUCTIONS = 'auctions',
	FAN_REWARDS = 'fan-rewards'
}

export type RewardsTabType = null | TabsEnum.AUCTIONS | TabsEnum.FAN_REWARDS;
